import React, { useEffect, useState } from "react";
import BookmarksPage from "./BookmarksPage";
import FavoriteButton from "../components/FavoriteButton";
import { useParams } from "react-router-dom";
import apiClient from "../services/apiClient";
import { useTranslation } from 'react-i18next';

const ChaptersListPage = () => {
  const { id } = useParams(); 
  const [chapters, setChapters] = useState(null);
  const [loading, setLoading] = useState(true);
  const { t } = useTranslation();

  useEffect(() => {
    // Fetch nội dung chương từ API
    apiClient.get(`/api/v1/stories/${id}/chapters`)
      .then((response) => {
        setChapters(response.data);
        setLoading(false);
      })
      .catch((error) => console.error("Error fetching chapter:", error));
  }, [id]);

  if (loading) {
    return <p>{t('loading')}</p>;
  }

  if (!chapters) {
    return <p>{t('noChaptersFound')}</p>;
  }

  return (
    <>
      <BookmarksPage storyId={id} />
      <FavoriteButton storyId={id} />
      <div>
        {chapters.map((chapter) => (
          <div key={chapter.id} className="container mx-auto p-4">
            <a href={`/stories/${id}/chapters/${chapter.id}`} className="text-blue-500">
              <h1 className="text-2xl font-bold mb-4">{chapter.title}</h1>
              <div className="whitespace-pre-line text-justify leading-7">
                {chapter.content}
              </div>
            </a>
          </div>
        ))}
      </div>
    </>
  );
};

export default ChaptersListPage;